// extracted by mini-css-extract-plugin
module.exports = {"leftIconWrapper":"PasswordInput_leftIconWrapper__tyAWN","eyeIcon":"PasswordInput_eyeIcon__1m08F"};